<div class="column">
	<p
		i18n
		class="padding__bottom--medium">
		Select a new contractor for the order {{ orderNumber }}
	</p>
	<epic-form-field [text]="selectContractor">
		<epic-autocomplete
			[control]="control"
			[searchValue]="searchValue"
			(searchChange)="handleSearchValueChanges($event)">
			@if (isLoading) {
				<epic-option
					[text]="pleaseWaitText"
					[isPlaceholder]="true" />
			}

			@for (option of options; track option) {
				<epic-option
					[text]="option.name"
					[value]="option.id" />
			} @empty {
				@if (!isLoading) {
					<epic-option
						[text]="noResultsText"
						[isPlaceholder]="true" />
				}
			}
		</epic-autocomplete>
	</epic-form-field>
	<div class="row-reverse padding__top--medium">
		<epic-button
			[text]="textSubmit"
			(onClick)="handleSubmit()" />
	</div>
</div>
